import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import AddForm from '../AddForm';
import { getConfigDetails } from '../tableData';
import { useParams } from 'react-router-dom';
import { useNotification } from '../../../hooks/NotificationContext';
import { addEntity } from '../../../modules/config';
import Modal from '../../../ui/layout/Modal';

const CustomConfigCreateForm = ({ configType, fetchDropdownData }) => {
  const { heading, group } = getConfigDetails(configType);
  const [open, setOpen] = useState(false);
  const { addNotification } = useNotification();
  const { projectId } = useParams();

  const handleSubmit = async (formData) => {
    try {
      await addEntity({ entity: { ...formData, group } }, projectId);
      addNotification('success', `${heading} added successfully`);
      fetchDropdownData();
      setOpen(false);
    } catch (error) {
      addNotification(
        'danger',
        error.message || `Failed to create ${heading}. Please try again.`
      );
    }
  };

  return (
    <>
      <Box sx={{ textAlign: 'left' }}>
        <Button
          variant="text"
          color="primary"
          size="small"
          sx={{ p: 0, minWidth: 'auto', textTransform: 'none' }}
          onClick={() => setOpen(true)}>
          {`+ Add New ${heading}`}
        </Button>
      </Box>

      <Modal
        modalTitle={`Add New ${heading}`}
        width="xs"
        open={open}
        handleClose={() => setOpen(false)}>
        <AddForm
          entityType={configType}
          group={group}
          handleSubmit={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default CustomConfigCreateForm;
